import { apiClient } from "../client";
const TYPE_TO_PASCAL = {
    urgent_action_required: "UrgentActionRequired",
    priority_action: "PriorityAction",
    normal_action: "NormalAction",
    confirmation: "Confirmation",
    reminder: "Reminder",
};
function toGeneralNotificationPayload(data) {
    return {
        title: data.title,
        message: data.message,
        type: TYPE_TO_PASCAL[data.type],
        ...(data.targetUserId !== undefined && { targetUserId: data.targetUserId }),
        ...(data.targetContactId !== undefined && {
            targetContactId: data.targetContactId,
        }),
        ...(data.targetRole !== undefined && { targetRole: data.targetRole }),
        ...(data.referenceData !== undefined && {
            referenceData: data.referenceData,
        }),
        ...(data.senderName !== undefined && { senderName: data.senderName }),
        ...(data.isSystem !== undefined && { isSystem: data.isSystem }),
    };
}
const ENDPOINTS = {
    BASE: "/notifications",
    GENERAL: "/notifications/general",
    BY_JOB: "/notifications/job",
    ME: "/notifications/me",
    ME_READ_ALL: "/notifications/me/read-all",
};
function buildMeParams(params) {
    if (!params)
        return "";
    const search = new URLSearchParams();
    if (params.limit != null)
        search.set("limit", String(params.limit));
    if (params.offset != null)
        search.set("offset", String(params.offset));
    if (params.unreadOnly === true)
        search.set("unreadOnly", "true");
    if (params.unreadOnly === false)
        search.set("unreadOnly", "false");
    if (params.readOnly === true)
        search.set("readOnly", "true");
    if (params.types?.length)
        search.set("types", params.types.join(","));
    if (params.roles?.length)
        search.set("roles", params.roles.join(","));
    const q = search.toString();
    return q ? `?${q}` : "";
}
export const notificationsService = {
    // General notifications: list for current user
    getMyNotifications: (params) => apiClient.get(`${ENDPOINTS.ME}${buildMeParams(params)}`),
    // Mark all general notifications for current user as read
    markAllMyNotificationsAsRead: () => apiClient.post(ENDPOINTS.ME_READ_ALL),
    // Get notifications for a job
    getNotificationsByJob: (jobId) => apiClient.get(`${ENDPOINTS.BY_JOB}/${jobId}`),
    // Get unread count for a job
    getUnreadCount: (jobId) => apiClient.get(`${ENDPOINTS.BY_JOB}/${jobId}/unread-count`),
    // Get a single notification
    getNotification: (id) => apiClient.get(`${ENDPOINTS.BASE}/${id}`),
    // Create a notification (general)
    createNotification: (data) => apiClient.post(ENDPOINTS.GENERAL, toGeneralNotificationPayload(data)),
    // Mark notification as read. Optionally pass actionedByName (full name) for display.
    markAsRead: (id, options) => apiClient.post(`${ENDPOINTS.BASE}/${id}/read`, options ?? {}),
    // Mark all notifications for a job as read
    markAllAsRead: (jobId) => apiClient.post(`${ENDPOINTS.BY_JOB}/${jobId}/read-all`),
    // Delete a notification
    deleteNotification: (id) => apiClient.delete(`${ENDPOINTS.BASE}/${id}`),
};
